<aside class="admin-toolbar" id="admin-toolbar">
  <div class="admin-toolbar__displace-placeholder" data-offset-left=""></div>

  <div class="admin-toolbar__scroll-wrapper">
    <h2 id="admin-toolbar" class="visually-hidden">Administrative toolbar</h2>

    <nav id="menu-builder" class="admin-toolbar__content" aria-labelledby="admin-toolbar">
      <div class="admin-toolbar__header">
        <a class="admin-toolbar__logo" href="/en">
          <img alt="Drupal logo" src="/modules/navigation/assets/images/logo.svg" loading="eager" width="32" height="32">
        </a>
        <button class="toolbar-button toolbar-button--icon--cross admin-toolbar__close-button" aria-controls="admin-toolbar" data-once="admin-toolbar-trigger" aria-expanded="false">
          <span class="trigger-state visually-hidden">Collapse sidebar</span>
        </button>
      </div>
      <div class="admin-toolbar__item toolbar-block">
        <h3 id="menu--shortcuts" class="toolbar-block__title visually-hidden focusable">Shortcuts</h3>
        <ul class="toolbar-block__list" aria-labelledby="menu--shortcuts">
          <li id="item-shortcuts--2" class="toolbar-block__list-item toolbar-popover" data-toolbar-popover="">
            <button class="toolbar-button toolbar-button--icon--shortcuts" aria-controls="item-shortcuts--2" aria-expanded="false" data-toolbar-popover-control="">
              <span data-toolbar-action="" class="visually-hidden">Extend</span>
              <span class="toolbar-button__label">Shortcuts</span>
            </button>
            <div class="toolbar-popover__wrapper" data-toolbar-popover-wrapper="">
              <div class="toolbar-popover__arrow" data-toolbar-popover-arrow=""></div>
              <button class="toolbar-popover__header toolbar-button toolbar-button--shortcuts" tabindex="-1">
                <span>Shortcuts</span>
              </button>

              <ul class="toolbar-menu toolbar-popover__menu">
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/node/19/edit" class="toolbar-menu__link">Edit Basic page Acerca de Umami [Spanish translation]</a>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/node/add" class="toolbar-menu__link">Add content</a>
                </li>

              </ul>
            </div>
          </li>


        </ul>
      </div>

      <div class="admin-toolbar__item toolbar-block">
        <h3 id="menu--content" class="toolbar-block__title visually-hidden focusable">Content</h3>
        <ul class="toolbar-block__list" aria-labelledby="menu--content">
          <li id="item-create" class="toolbar-block__list-item toolbar-popover toolbar-popover--expanded toolbar-popover--has-current-polyfill" data-toolbar-popover="">
            <button class="toolbar-button toolbar-button--icon--create" aria-controls="item-create" aria-expanded="false" data-toolbar-popover-control="">
              <span data-toolbar-action="" class="visually-hidden">Collapse</span>
              <span class="toolbar-button__label">Create</span>
            </button>
            <div class="toolbar-popover__wrapper" data-toolbar-popover-wrapper="">
              <div class="toolbar-popover__arrow" data-toolbar-popover-arrow=""></div>
              <button class="toolbar-popover__header toolbar-button toolbar-button--create" tabindex="-1">
                <span>Create</span>
              </button>

              <ul class="toolbar-menu toolbar-popover__menu">
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/node/add/page" class="toolbar-menu__link current is-active">Basic page</a>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/node/add/article" class="toolbar-menu__link">Article</a>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/node/add/recipe" class="toolbar-menu__link">Recipe</a>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/media/add/image" class="toolbar-menu__link">Image</a>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/media/add/document" class="toolbar-menu__link">Document</a>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/admin/people/create" class="toolbar-menu__link">User</a>
                </li>

              </ul>
            </div>
          </li>

          <li id="item-content--2" class="toolbar-block__list-item">
            <a href="/en/admin/content" class="toolbar-button toolbar-button--icon--content" data-drupal-tooltip="Content" data-drupal-tooltip-class="admin-toolbar__tooltip">
              <span class="toolbar-button__label">Content</span>
            </a>
            <div class="tooltip admin-toolbar__tooltip" style="left: 257px; top: 269.766px;">
              Content
            </div>
          </li>

          <li id="item-files" class="toolbar-block__list-item">
            <a href="/admin/content/files" class="toolbar-button toolbar-button--icon--files" data-drupal-tooltip="Files" data-drupal-tooltip-class="admin-toolbar__tooltip">
              <span class="toolbar-button__label">Files</span>
            </a>
            <div class="tooltip admin-toolbar__tooltip" style="left: 257px; top: 309.766px;">
              Files
            </div>
          </li>

          <li id="item-media" class="toolbar-block__list-item">
            <a href="/admin/content/media" class="toolbar-button toolbar-button--icon--media" data-drupal-tooltip="Media" data-drupal-tooltip-class="admin-toolbar__tooltip">
              <span class="toolbar-button__label">Media</span>
            </a>
            <div class="tooltip admin-toolbar__tooltip" style="left: 257px; top: 454px;">
              Media
            </div>
          </li>


        </ul>
      </div>


      <!-- END OUTPUT from 'modules/navigation/templates/menu-region--content.html.twig' -->


      <!-- THEME DEBUG -->
      <!-- THEME HOOK: 'menu_region__content' -->
      <!-- FILE NAME SUGGESTIONS:
                     x menu-region--content.html.twig
                     x menu-region--content.html.twig
                     * menu-region.html.twig
                  -->
      <!-- BEGIN OUTPUT from 'modules/navigation/templates/menu-region--content.html.twig' -->
        <div class="admin-toolbar__item toolbar-block"> <h3 id="menu--admin" class="toolbar-block__title visually-hidden focusable">Administration</h3>
        <ul class="toolbar-block__list" aria-labelledby="menu--admin">
          <li id="item-structure" class="toolbar-block__list-item toolbar-popover" data-toolbar-popover="">
            <button class="toolbar-button toolbar-button--icon--system-admin-structure" aria-controls="item-structure" aria-expanded="false" data-toolbar-popover-control="">
              <span data-toolbar-action="" class="visually-hidden">Extend</span>
              <span class="toolbar-button__label">Structure</span>
            </button>
            <div class="toolbar-popover__wrapper" data-toolbar-popover-wrapper="">
              <div class="toolbar-popover__arrow" data-toolbar-popover-arrow=""></div>
              <button class="toolbar-popover__header toolbar-button toolbar-button--system-admin-structure" tabindex="-1">
                <span>Structure</span>
              </button>

              <ul class="toolbar-menu toolbar-popover__menu">
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/admin/structure/block" class="toolbar-menu__link">Block layout</a>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/admin/structure/block-content" class="toolbar-menu__link">Block types</a>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/admin/structure/contact" class="toolbar-menu__link">Contact forms</a>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/admin/structure/types" class="toolbar-menu__link">Content types</a>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <button class="toolbar-menu__link toolbar-menu__link--1" data-toolbar-menu-trigger="" aria-expanded="false">
                    <span class="toolbar-menu__link-action visually-hidden">Extend</span>
                    <span class="toolbar-menu__link-title">Display modes</span>
                  </button>
                  <ul class="toolbar-menu toolbar-menu--level-2">
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/structure/display-modes/form" class="toolbar-menu__link">Form modes</a>
                    </li>
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/structure/display-modes/view" class="toolbar-menu__link">View modes</a>
                    </li>

                  </ul>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/admin/structure/media" class="toolbar-menu__link">Media types</a>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/admin/structure/menu" class="toolbar-menu__link">Menus</a>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/admin/structure/taxonomy" class="toolbar-menu__link">Taxonomy</a>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/admin/structure/views" class="toolbar-menu__link">Views</a>
                </li>

              </ul>
            </div>
          </li>

          <li id="item-appearance" class="toolbar-block__list-item">
            <a href="/en/admin/appearance" class="toolbar-button toolbar-button--icon--system-themes-page" data-drupal-tooltip="Appearance" data-drupal-tooltip-class="admin-toolbar__tooltip">
              <span class="toolbar-button__label">Appearance</span>
            </a>
            <div class="tooltip admin-toolbar__tooltip" style="left: 257px; top: 454px;">
              Appearance
            </div>
          </li>

          <li id="item-extend" class="toolbar-block__list-item">
            <a href="/en/admin/modules" class="toolbar-button toolbar-button--icon--system-modules-list" data-drupal-tooltip="Extend" data-drupal-tooltip-class="admin-toolbar__tooltip">
              <span class="toolbar-button__label">Extend</span>
            </a>
            <div class="tooltip admin-toolbar__tooltip" style="left: 257px; top: 454px;">
              Extend
            </div>
          </li>

          <li id="item-configuration" class="toolbar-block__list-item toolbar-popover" data-toolbar-popover="">
            <button class="toolbar-button toolbar-button--icon--system-admin-config" aria-controls="item-configuration" aria-expanded="false" data-toolbar-popover-control="">
              <span data-toolbar-action="" class="visually-hidden">Extend</span>
              <span class="toolbar-button__label">Configuration</span>
            </button>
            <div class="toolbar-popover__wrapper" data-toolbar-popover-wrapper="">
              <div class="toolbar-popover__arrow" data-toolbar-popover-arrow=""></div>
              <button class="toolbar-popover__header toolbar-button toolbar-button--system-admin-config" tabindex="-1">
                <span>Configuration</span>
              </button>

              <ul class="toolbar-menu toolbar-popover__menu">
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <button class="toolbar-menu__link toolbar-menu__link--1" data-toolbar-menu-trigger="" aria-expanded="false">
                    <span class="toolbar-menu__link-action visually-hidden">Extend</span>
                    <span class="toolbar-menu__link-title">People</span>
                  </button>
                  <ul class="toolbar-menu toolbar-menu--level-2">
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/people/accounts" class="toolbar-menu__link">Account settings</a>
                    </li>

                  </ul>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <button class="toolbar-menu__link toolbar-menu__link--1" data-toolbar-menu-trigger="" aria-expanded="false">
                    <span class="toolbar-menu__link-action visually-hidden">Extend</span>
                    <span class="toolbar-menu__link-title">System</span>
                  </button>
                  <ul class="toolbar-menu toolbar-menu--level-2">
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/system/site-information" class="toolbar-menu__link">Basic site settings</a>
                    </li>
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/system/cron" class="toolbar-menu__link">Cron</a>
                    </li>

                  </ul>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <button class="toolbar-menu__link toolbar-menu__link--1" data-toolbar-menu-trigger="" aria-expanded="false">
                    <span class="toolbar-menu__link-action visually-hidden">Extend</span>
                    <span class="toolbar-menu__link-title">Content authoring</span>
                  </button>
                  <ul class="toolbar-menu toolbar-menu--level-2">
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/content/formats" class="toolbar-menu__link">Text formats and editors</a>
                    </li>

                  </ul>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <button class="toolbar-menu__link toolbar-menu__link--1" data-toolbar-menu-trigger="" aria-expanded="false">
                    <span class="toolbar-menu__link-action visually-hidden">Extend</span>
                    <span class="toolbar-menu__link-title">User interface</span>
                  </button>
                  <ul class="toolbar-menu toolbar-menu--level-2">
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/user-interface/shortcut" class="toolbar-menu__link">Shortcuts</a>
                    </li>

                  </ul>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <button class="toolbar-menu__link toolbar-menu__link--1" data-toolbar-menu-trigger="" aria-expanded="false">
                    <span class="toolbar-menu__link-action visually-hidden">Extend</span>
                    <span class="toolbar-menu__link-title">Development</span>
                  </button>
                  <ul class="toolbar-menu toolbar-menu--level-2">
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/development/performance" class="toolbar-menu__link">Performance</a>
                    </li>
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/development/settings" class="toolbar-menu__link">Development settings</a>
                    </li>
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/development/logging" class="toolbar-menu__link">Logging and errors</a>
                    </li>
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/development/maintenance" class="toolbar-menu__link">Maintenance mode</a>
                    </li>
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/development/configuration" class="toolbar-menu__link">Configuration synchronization</a>
                    </li>

                  </ul>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <button class="toolbar-menu__link toolbar-menu__link--1" data-toolbar-menu-trigger="" aria-expanded="false">
                    <span class="toolbar-menu__link-action visually-hidden">Extend</span>
                    <span class="toolbar-menu__link-title">Media</span>
                  </button>
                  <ul class="toolbar-menu toolbar-menu--level-2">
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/media/file-system" class="toolbar-menu__link">File system</a>
                    </li>
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/media/image-styles" class="toolbar-menu__link">Image styles</a>
                    </li>
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/media/media-library" class="toolbar-menu__link">Media Library settings</a>
                    </li>
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/media/media-settings" class="toolbar-menu__link">Media settings</a>
                    </li>
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/media/responsive-image-style" class="toolbar-menu__link">Responsive image styles</a>
                    </li>
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/media/image-toolkit" class="toolbar-menu__link">Image toolkit</a>
                    </li>

                  </ul>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <button class="toolbar-menu__link toolbar-menu__link--1" data-toolbar-menu-trigger="" aria-expanded="false">
                    <span class="toolbar-menu__link-action visually-hidden">Extend</span>
                    <span class="toolbar-menu__link-title">Search and metadata</span>
                  </button>
                  <ul class="toolbar-menu toolbar-menu--level-2">
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/search/pages" class="toolbar-menu__link">Search pages</a>
                    </li>
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/search/path" class="toolbar-menu__link">URL aliases</a>
                    </li>

                  </ul>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <button class="toolbar-menu__link toolbar-menu__link--1" data-toolbar-menu-trigger="" aria-expanded="false">
                    <span class="toolbar-menu__link-action visually-hidden">Extend</span>
                    <span class="toolbar-menu__link-title">Region and language</span>
                  </button>
                  <ul class="toolbar-menu toolbar-menu--level-2">
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/regional/settings" class="toolbar-menu__link">Regional settings</a>
                    </li>
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/regional/date-time" class="toolbar-menu__link">Date and time formats</a>
                    </li>
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/regional/language" class="toolbar-menu__link">Languages</a>
                    </li>
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/regional/content-language" class="toolbar-menu__link">Content language and translation</a>
                    </li>
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/regional/translate" class="toolbar-menu__link">User interface translation</a>
                    </li>
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/regional/config-translation" class="toolbar-menu__link">Configuration translation</a>
                    </li>

                  </ul>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <button class="toolbar-menu__link toolbar-menu__link--1" data-toolbar-menu-trigger="" aria-expanded="false">
                    <span class="toolbar-menu__link-action visually-hidden">Extend</span>
                    <span class="toolbar-menu__link-title">Web services</span>
                  </button>
                  <ul class="toolbar-menu toolbar-menu--level-2">
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/services/rss-publishing" class="toolbar-menu__link">RSS publishing</a>
                    </li>
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/services/linkset" class="toolbar-menu__link">Menu Linkset Settings</a>
                    </li>

                  </ul>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <button class="toolbar-menu__link toolbar-menu__link--1" data-toolbar-menu-trigger="" aria-expanded="false">
                    <span class="toolbar-menu__link-action visually-hidden">Extend</span>
                    <span class="toolbar-menu__link-title">Workflow</span>
                  </button>
                  <ul class="toolbar-menu toolbar-menu--level-2">
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/workflow/workflows" class="toolbar-menu__link">Workflows</a>
                    </li>
                    <li class="toolbar-menu__item toolbar-menu__item--level-2">
                      <a href="/en/admin/config/workflow/workspaces" class="toolbar-menu__link">Workspaces</a>
                    </li>

                  </ul>
                </li>

              </ul>
            </div>
          </li>

          <li id="item-people--2" class="toolbar-block__list-item">
            <a href="/en/admin/people" class="toolbar-button toolbar-button--icon--entity-user-collection" data-drupal-tooltip="People" data-drupal-tooltip-class="admin-toolbar__tooltip">
              <span class="toolbar-button__label">People</span>
            </a>
            <div class="tooltip admin-toolbar__tooltip" style="left: 257px; top: 454px;">
              People
            </div>
          </li>

          <li id="item-reports" class="toolbar-block__list-item toolbar-popover" data-toolbar-popover="">
            <button class="toolbar-button toolbar-button--icon--system-admin-reports" aria-controls="item-reports" aria-expanded="false" data-toolbar-popover-control="">
              <span data-toolbar-action="" class="visually-hidden">Extend</span>
              <span class="toolbar-button__label">Reports</span>
            </button>
            <div class="toolbar-popover__wrapper" data-toolbar-popover-wrapper="">
              <div class="toolbar-popover__arrow" data-toolbar-popover-arrow=""></div>
              <button class="toolbar-popover__header toolbar-button toolbar-button--system-admin-reports" tabindex="-1">
                <span>Reports</span>
              </button>

              <ul class="toolbar-menu toolbar-popover__menu">
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/admin/reports/status" class="toolbar-menu__link">Status report</a>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/admin/reports/updates" class="toolbar-menu__link">Available updates</a>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/admin/reports/dblog" class="toolbar-menu__link">Recent log messages</a>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/admin/reports/translations" class="toolbar-menu__link">Available translation updates</a>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/admin/reports/fields" class="toolbar-menu__link">Field list</a>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/admin/reports/access-denied" class="toolbar-menu__link">Top 'access denied' errors</a>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/admin/reports/page-not-found" class="toolbar-menu__link">Top 'page not found' errors</a>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/admin/reports/search" class="toolbar-menu__link">Top search phrases</a>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/admin/reports/views-plugins" class="toolbar-menu__link">Views plugins</a>
                </li>

              </ul>
            </div>
          </li>


        </ul>
      </div>


    </nav>

    <nav id="menu-footer" class="admin-toolbar__footer" aria-labelledby="admin-toolbar-footer">
      <h3 id="admin-toolbar-footer" class="visually-hidden">Administrative toolbar footer</h3>

      <div class="admin-toolbar__item toolbar-block">
        <ul class="toolbar-block__list">
          <li class="toolbar-block__list-item" id="item-user--2">
            <button aria-controls="admin-toolbar" aria-expanded="false" class="toolbar-button toolbar-button--icon--sidebar-toggle admin-toolbar__toggle" data-drupal-tooltip="Expand sidebar" data-drupal-tooltip-class="admin-toolbar__tooltip">
              <span class="trigger-state toolbar-button__label">Collapse sidebar</span>
            </button>
            <div class="tooltip admin-toolbar__tooltip" style="left: 257px; top: 348px;">
              Expand sidebar
            </div>
          </li>
          <li class="toolbar-block__list-item">
            <a href="/en/admin/help" class="toolbar-button toolbar-button--icon--help" data-drupal-tooltip="Help" data-drupal-tooltip-class="admin-toolbar__tooltip">
              <span class="toolbar-button__label">Help</span>
            </a>
            <div class="tooltip admin-toolbar__tooltip" style="left: 257px; top: 388px;">
              Help
            </div>
          </li>
          <li id="admin-toolbar-user-menu" class="toolbar-block__list-item toolbar-block__list-item--user toolbar-popover" data-toolbar-popover="">
            <button class="toolbar-button toolbar-button--icon--user toolbar-popover__control" aria-controls="admin-toolbar-user-menu" aria-expanded="false" data-toolbar-popover-control="">
              <span class="toolbar-button__action visually-hidden" data-toolbar-action="">Extend</span>
              <span class="toolbar-button__label">User</span>
            </button>
            <div class="toolbar-popover__wrapper" data-toolbar-popover-wrapper="">
              <div class="toolbar-popover__arrow" data-toolbar-popover-arrow=""></div>
              <button class="toolbar-button toolbar-button--icon--user toolbar-popover__header" tabindex="-1">
                <span>User</span>
              </button>
              <ul class="toolbar-menu toolbar-popover__menu">
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/user" class="toolbar-menu__link">
                    <span>Profile</span>
                  </a>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/admin/config/people/accounts" class="toolbar-menu__link">
                    <span>Settings</span>
                  </a>
                </li>
                <li class="toolbar-menu__item toolbar-menu__item--level-1">
                  <a href="/en/user/logout" class="toolbar-menu__link">
                    <span>Sign out</span>
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>

      <!-- END OUTPUT from 'modules/navigation/templates/menu-region--footer.html.twig' -->
    </nav>
  </div>
</aside>
<div class="admin-toolbar-overlay" aria-controls="admin-toolbar" aria-expanded="false"></div>
<script>
  if (localStorage.getItem('Drupal.navigation.sidebarExpanded') !== 'false' && (window.matchMedia('(min-width: 1024px)').matches)) {
    document.documentElement.setAttribute('data-admin-toolbar', 'expanded');
  }
</script>
